import React from 'react';
import { UsageInfo } from './types';

export const UsageDisplay: React.FC<{ 
  usage: UsageInfo;
  setIsSubscriptionDialogOpen: (open: boolean) => void; 
}> = ({ usage, setIsSubscriptionDialogOpen }) => {
  return (
    <div className="flex items-center gap-3 px-3 py-1 bg-slate-700/50 rounded-md text-sm">
      <div className="flex items-center gap-2">
        <span className="text-emerald-400 font-medium capitalize">{usage.tier}</span>
      </div>
      
      {usage.tier === 'free' && (
        <button
          onClick={() => setIsSubscriptionDialogOpen(true)}
          className="text-xs px-2 py-1 bg-emerald-500 text-slate-900 rounded hover:bg-emerald-400 transition-colors"
        >
          Upgrade
        </button>
      )}
    </div>
  );
};

export default UsageDisplay;
